import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageTitle, Spinner } from "../../components/Shell";
import { toast } from "sonner";
import { Landmark } from "lucide-react";

export default function Branding({ onSaved }) {
  const [tenant, setTenant] = useState(null);
  const [form, setForm] = useState({ brand_name: "", logo_url: "", primary_color: "#0284C7", secondary_color: "#475569", login_message: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/tenant").then((r) => {
      setTenant(r.data);
      setForm({ ...r.data.branding });
    }).catch(() => {});
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const res = await api.put("/tenant/branding", form);
      setTenant(res.data);
      onSaved?.(res.data);
      toast.success("Jenama dikemas kini");
    } catch {
      toast.error("Error");
    } finally {
      setBusy(false);
    }
  };

  if (!tenant) return <Spinner />;

  const Field = ({ label, children, testid }) => (
    <div>
      <label className="block text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground mb-1.5">{label}</label>
      {children}
    </div>
  );

  return (
    <div data-testid="tenant-branding">
      <PageTitle title="White Label & Jenama" sub={`${tenant.slug}.kopera.app`} />
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-card rounded-xl border border-brand-deep/10 p-6 space-y-5">
          <Field label="Nama Jenama">
            <input data-testid="branding-name-input" value={form.brand_name} onChange={(e) => setForm({ ...form, brand_name: e.target.value })} className="w-full rounded-lg border border-input px-3.5 py-2.5 text-sm" />
          </Field>
          <Field label="URL Logo">
            <input data-testid="branding-logo-input" placeholder="https://..." value={form.logo_url} onChange={(e) => setForm({ ...form, logo_url: e.target.value })} className="w-full rounded-lg border border-input px-3.5 py-2.5 text-sm" />
          </Field>
          <div className="grid grid-cols-2 gap-4">
            <Field label="Warna Utama">
              <div className="flex items-center gap-2">
                <input data-testid="branding-primary-color" type="color" value={form.primary_color} onChange={(e) => setForm({ ...form, primary_color: e.target.value })} className="w-10 h-10 rounded-lg border border-input cursor-pointer" />
                <span className="font-mono text-xs">{form.primary_color}</span>
              </div>
            </Field>
            <Field label="Warna Kedua">
              <div className="flex items-center gap-2">
                <input data-testid="branding-secondary-color" type="color" value={form.secondary_color} onChange={(e) => setForm({ ...form, secondary_color: e.target.value })} className="w-10 h-10 rounded-lg border border-input cursor-pointer" />
                <span className="font-mono text-xs">{form.secondary_color}</span>
              </div>
            </Field>
          </div>
          <Field label="Mesej Skrin Log Masuk">
            <input data-testid="branding-login-msg" value={form.login_message} onChange={(e) => setForm({ ...form, login_message: e.target.value })} className="w-full rounded-lg border border-input px-3.5 py-2.5 text-sm" />
          </Field>
          <button data-testid="branding-save-btn" onClick={save} disabled={busy} className="w-full bg-brand-deep text-white rounded-xl py-3 text-sm font-bold hover:bg-brand-dark transition-colors disabled:opacity-50">
            {busy ? "Menyimpan..." : "Simpan Jenama"}
          </button>
        </div>

        <div>
          <div className="text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground mb-2">Pratonton Langsung</div>
          <div className="rounded-2xl overflow-hidden border border-brand-deep/15 shadow-lg" data-testid="branding-preview">
            <div className="p-6" style={{ backgroundColor: form.primary_color }}>
              <div className="flex items-center gap-3">
                {form.logo_url ? (
                  <img src={form.logo_url} alt="logo" className="w-10 h-10 rounded-lg object-cover bg-white" />
                ) : (
                  <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: form.secondary_color }}>
                    <Landmark className="w-5 h-5" style={{ color: form.primary_color }} />
                  </div>
                )}
                <span className="font-display font-bold text-white text-lg">{form.brand_name || tenant.name}</span>
              </div>
              <p className="mt-4 text-white/80 text-sm">{form.login_message || "Selamat datang ke portal ahli"}</p>
            </div>
            <div className="bg-white p-6">
              <div className="text-xs uppercase tracking-[0.15em] text-muted-foreground">Portal Ahli</div>
              <div className="mt-3 grid grid-cols-2 gap-3">
                <div className="rounded-xl p-4" style={{ backgroundColor: `${form.primary_color}12` }}>
                  <div className="text-[10px] uppercase tracking-wide text-muted-foreground">Baki Saham</div>
                  <div className="font-mono font-bold mt-1" style={{ color: form.primary_color }}>RM 5,200.00</div>
                </div>
                <div className="rounded-xl p-4" style={{ backgroundColor: `${form.secondary_color}25` }}>
                  <div className="text-[10px] uppercase tracking-wide text-muted-foreground">Yuran</div>
                  <div className="font-mono font-bold mt-1" style={{ color: form.secondary_color }}>RM 0.00</div>
                </div>
              </div>
              <button className="mt-4 w-full rounded-xl py-2.5 text-sm font-bold text-white" style={{ backgroundColor: form.primary_color }}>
                Lihat Penyata
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
